import React, { useState, useEffect } from 'react';

import { Typography, CircularButton } from '@hpstellar/core';

import './sticky-card.less';

export default function StickyCard({ id, title, fps, imgUrl, onClick, onRemove, index, selecting }) {
    const [hover, setHover] = useState(false);

    useEffect(() => {
        setHover(false);
    }, [selecting]);

    if (!title) {
        return (
            <div className="stickyCardContainer add" onClick={() => onClick(id)}>
                <CircularButton className="stickyButton" icon="plus" />
                <Typography className="addGame" variant="boldXS">
                    ADD GAME
                </Typography>
            </div>
        );
    }

    return (
        <div
            className={`stickyCardContainer${hover ? ' hover' : ''}${imgUrl ? '' : ' noImg'}`}
            onClick={() => onRemove(index)}
        >
            <div className="hoverLayer" onMouseOver={() => setHover(true)} onMouseOut={() => setHover(false)}>
                <div></div>
            </div>
            <div className="gameImg">
                {!hover && (imgUrl ? <img src={imgUrl} /> : <div className="fpsImgGradient" />)}
                {hover && (
                    <div>
                        <CircularButton className="removeButton" icon="cross" size="small" useTransparentBg />
                        <Typography className="removeGame" variant="boldXS">
                            REMOVE
                        </Typography>
                    </div>
                )}
            </div>
            <Typography className="gameTitle" variant="boldXS">
                {title}
            </Typography>
            <Typography className="fps" variant="list">
                {fps}
            </Typography>
        </div>
    );
}
